const HowWeWork = () => {
  const steps = [
    {
      number: "01",
      title: "Experience Design",
      description: "We conceptualise and design the full experience — from theme and structure to flow, branding, and audience engagement."
    },
    {
      number: "02",
      title: "IP Ownership",
      description: "We retain ownership of the experience format, ensuring long-term value, consistency, and protection of the brand."
    },
    {
      number: "03",
      title: "Partner Execution",
      description: "Licensed travel operators execute the experience on the ground, handling sales, logistics, and traveller management."
    }
  ];

  return (
    <section className="section-container">
      <div className="text-center mb-16">
        <h2 className="section-title">How We Work</h2>
        <p className="section-subtitle">
          A structured approach to creating and scaling destination experiences through strategic partnerships.
        </p>
      </div>

      <div className="relative">
        {/* Connecting line */}
        <div className="hidden lg:block absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 w-3/4 h-1 bg-gradient-to-r from-primary via-primary/50 to-primary"></div>
        
        <div className="grid lg:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <div key={step.number} className="relative">
              <div className="card text-center">
                <div className="w-16 h-16 bg-primary text-white rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-6">
                  {step.number}
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">{step.title}</h3>
                <p className="text-gray-600">{step.description}</p>
              </div>
              
              {/* Arrow for mobile */}
              {index < steps.length - 1 && (
                <div className="lg:hidden flex justify-center my-4">
                  <svg className="w-6 h-6 text-primary" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z" clipRule="evenodd" />
                  </svg>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowWeWork;